import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { FtNo } from "../../../../../locales/en";

const DataCellLoan = React.memo(({ cell, column, row }) => {
  try {
    let content = cell?.render ? cell.render("Cell") : (cell?.value ?? cell);

    if (column?.id === "quoteId") {
      const value = cell?.value ?? "";
      const quoteId = value.startsWith?.(FtNo) ? value.slice(2) : value;
      content = (
        <Link to={`/dashboard/invoice-details/${quoteId}`}>
          {cell.render("Cell")}
        </Link>
      );
    }

    if (column?.id === "customerName") {
      const userAccountId = row?.original?.userAccountId;
      content = (
        <Link to={`/admin/access/client-details/${userAccountId}`}>
          {cell.render("Cell")}
        </Link>
      );
    }

    return (
      <td {...(cell?.getCellProps ? cell.getCellProps() : {})}>{content}</td>
    );
  } catch {
    return <td />;
  }
});

DataCellLoan.displayName = "DataCellLoan";

DataCellLoan.propTypes = {
  cell: PropTypes.object,
  column: PropTypes.object,
  row: PropTypes.object,
  onOpenClient: PropTypes.func
};

export default DataCellLoan;
